import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';

import { 
  Box, 
  Paper, 
  Typography, 
  Grid, 
  Card, 
  CardMedia, 
  CardContent,
  Chip
} from '@mui/material';

import imageObj from '../constants/images';
import { modernDesignSystem } from '../constants/themes';
import { toast } from 'react-toastify';

const BaseMapsUtil = () => {
  const { map } = useSelector((state) => state.globalMaps[0]);

  const [activeLayer, setActiveLayer] = useState('Google Maps Uydu');

  const baseLayers = useSelector((state) => state.layersBaseMap);

  const setActiveMap = (activeMap) => {
    let activeBaseMap = map
      .getLayers()
      .array_.find((layer) => layer.get('title') === activeMap);
    activeBaseMap.setVisible(true);
    let titleActiveBaseMap = activeBaseMap.get('title');
    setActiveLayer(titleActiveBaseMap);
    toast.success(`${titleActiveBaseMap} altlık haritası aktif hale getirildi.`);
    map.getLayers().array_.map((layer) => {
      if (
        layer.values_.baseLayer &&
        layer.get('title') !== 'Basemap' &&
        layer !== activeBaseMap
      ) {
        layer.setVisible(false);
      }
    });
  };

  return (
    <Box
      sx={{
        padding: '8px',
        height: '100%',
        overflow: 'auto',
        backgroundColor: 'transparent',
        
        // Custom scrollbar
        '&::-webkit-scrollbar': {
          width: '6px',
        },
        '&::-webkit-scrollbar-track': {
          background: modernDesignSystem.colors.neutral.gray100,
          borderRadius: '3px',
        },
        '&::-webkit-scrollbar-thumb': {
          background: modernDesignSystem.colors.primary.main,
          borderRadius: '3px',
          '&:hover': {
            background: modernDesignSystem.colors.primary.dark,
          },
        },
      }}
    >
      <Grid 
        container 
        spacing={2} 
        justifyContent="center" // Kartları ortala
        alignItems="stretch" // Tüm kartları aynı yükseklikte tut
      >
        {baseLayers.map((layer, index) => (
          <Grid 
            item 
            xs={12} 
            sm={6} 
            key={uuidv4()}
            sx={{
              display: 'flex',
              justifyContent: 'center' // Her grid item içinde kartı ortala
            }}
          >
            <Card
              onClick={() => setActiveMap(layer.get('title'))}
              sx={{
                width: '100%',
                maxWidth: '180px', // Daha kompakt boyut
                cursor: 'pointer',
                borderRadius: modernDesignSystem.borders.radius.medium,
                border: activeLayer === layer.get('title')
                  ? `3px solid ${modernDesignSystem.colors.primary.main}`
                  : `1px solid ${modernDesignSystem.colors.neutral.gray200}`,
                backgroundColor: activeLayer === layer.get('title')
                  ? modernDesignSystem.colors.primary.surface
                  : modernDesignSystem.colors.neutral.white,
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                position: 'relative',
                overflow: 'hidden',
                
                // Hover efektleri
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: activeLayer === layer.get('title')
                    ? `0 8px 24px ${modernDesignSystem.colors.primary.main}40`
                    : '0 8px 24px rgba(0, 0, 0, 0.15)',
                  borderColor: modernDesignSystem.colors.primary.main,
                },
                
                // Aktif durum
                ...(activeLayer === layer.get('title') && {
                  boxShadow: `0 4px 16px ${modernDesignSystem.colors.primary.main}30`,
                })
              }}
            >
              {/* Aktif gösterge */}
              {activeLayer === layer.get('title') && (
                <Chip
                  label="AKTİF"
                  size="small"
                  sx={{
                    position: 'absolute',
                    top: '8px',
                    right: '8px',
                    backgroundColor: modernDesignSystem.colors.primary.main,
                    color: modernDesignSystem.colors.neutral.white,
                    fontSize: '10px',
                    fontWeight: 600,
                    zIndex: 2,
                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
                  }}
                />
              )}
              
              <CardMedia
                component="img"
                height="120" // Daha kompakt yükseklik
                image={imageObj.find((veri) => veri[0] === layer.get('title'))?.[1]}
                alt={layer.get('title')}
                sx={{
                  borderRadius: `${modernDesignSystem.borders.radius.medium} ${modernDesignSystem.borders.radius.medium} 0 0`,
                  objectFit: 'cover',
                  transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                  
                  '&:hover': {
                    transform: 'scale(1.05)',
                  }
                }}
              />
              
              <CardContent
                sx={{
                  padding: '8px 12px !important', // Kompakt padding
                  textAlign: 'center',
                  backgroundColor: 'inherit',
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: '12px',
                    fontWeight: 600,
                    color: activeLayer === layer.get('title')
                      ? modernDesignSystem.colors.primary.dark
                      : modernDesignSystem.colors.neutral.gray800,
                    lineHeight: 1.3,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {layer.get('title')}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default BaseMapsUtil;
